// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  --ink: #1b2838;
  --muted: #5c6b7a;
  --accent: #0f6cbd;
  --surface: #f4f7fb;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Segoe UI", sans-serif;
  color: var(--ink);
  background: var(--surface);
}

.scenario {
  min-height: 100vh;
  padding: 20px 22px;
}

h1 {
  margin: 0 0 18px;
  font-size: 22px;
  font-weight: 650;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: var(--muted);
}

input[type="range"] {
  width: 100%;
  accent-color: var(--accent);
}

.growth-readout {
  margin: 10px 0 18px;
  font-size: 16px;
}

.forecast-label {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}

.forecast-value {
  margin: 4px 0 0;
  font-size: 36px;
  font-weight: 650;
  letter-spacing: -0.03em;
}

.status {
  min-height: 1em;
  margin: 16px 0 0;
  font-size: 12px;
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[":root {\n  color-scheme: light;\n  --ink: #1b2838;\n  --muted: #5c6b7a;\n  --accent: #0f6cbd;\n  --surface: #f4f7fb;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Segoe UI\", sans-serif;\n  color: var(--ink);\n  background: var(--surface);\n}\n\n.scenario {\n  min-height: 100vh;\n  padding: 20px 22px;\n}\n\nh1 {\n  margin: 0 0 18px;\n  font-size: 22px;\n  font-weight: 650;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  color: var(--muted);\n}\n\ninput[type=\"range\"] {\n  width: 100%;\n  accent-color: var(--accent);\n}\n\n.growth-readout {\n  margin: 10px 0 18px;\n  font-size: 16px;\n}\n\n.forecast-label {\n  margin: 0;\n  font-size: 13px;\n  color: var(--muted);\n}\n\n.forecast-value {\n  margin: 4px 0 0;\n  font-size: 36px;\n  font-weight: 650;\n  letter-spacing: -0.03em;\n}\n\n.status {\n  min-height: 1em;\n  margin: 16px 0 0;\n  font-size: 12px;\n  color: var(--muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
